export const systemManagementRouteDef = [ 
    // {
    //     path:'custom_component',
    //     component:AppResourcePermissionComponent
    // }
    {
        path:'dashboard_master/:id',
        component:'DashboardMasterComponent',
        data : {
            selector: 'app-dashboard-master'
        }
    }
    
]    